import React, { useCallback, useContext, useEffect, useMemo } from 'react';
import { Link, useHistory } from 'react-router-dom'; // useHistory instead of useNavigate
import $ from 'jquery';

import LeftSideBar from '../../Components/Common/LeftSideBar';
import Footer from '../../Components/Common/Footer';
import TopBar from '../../Components/Common/TopBar';
import PageHeader from '../../Components/Common/PageHeader';
import RightSideBar from '../../Components/Common/RightSideBar';
import DashCard from '../../Components/Cards/OperationCards/DashCard';
import RecentSessions from '../../Components/RecentSessions';
import PopNewSession from '../../Components/Session/PopNewSession';
import ReservationChart from '../../Components/BarChart/ReservationChart';
import OperationsGraph from '../../Components/BarChart/OperationsGraph';
import RecentClamps from '../../Components/Clamps/RecentClamps';

import functions from '../../utils/functions';
import OperationContext, { OperationConsumer } from '../../Context/OperationContext';
import { AuthConsumer } from '../../Context/AuthContext';
import { RenderSecure } from '../../utils/script/RenderSecure';

const Dashboard = ({ onConfirmStartSession }) => {
  const history = useHistory();
  const userId = useMemo(() => functions.sessionGuard(), []);
  const { loadOperations, spaceAvailability} = useContext(OperationContext);

   useEffect(() => {
      loadOperations();
  }, []); // runs on mount (and if loadOperations ref changes)


  const onClickStartSession = useCallback(() => {
    $('#modal_new_session').modal('show');
  }, []);

  const ViewAllSpaces = useCallback(() => {
    history.push('/parking-space/available-space');
  }, [history]);

  const ViewFullMap = useCallback(() => {
    history.push('/parkingmap');
  }, [history]);

  const Buttons = useCallback(() => (
    <>
      <RenderSecure code="C-SESSION-01">
        <button className="btn ripple btn-success" onClick={onClickStartSession}>
          <i className="far fa-edit"></i> Start Session
        </button>
      </RenderSecure>

      <RenderSecure code="FIELD-ACTIVITY-00">
        <Link to="/operations/supervision" className="btn ripple btn-light">
          <i className="fa fa-user-check"></i> Field Supervision
        </Link>
      </RenderSecure>
    </>
  ), [onClickStartSession]);

  const CardSection = useCallback(() => (
    <OperationConsumer>
      {op => (
        <>
          <RenderSecure code="R-SESSION-02">
            <DashCard
              className="col-sm-6 col-md-4 col-xl-3"
              title="Active Sessions"
              icon="far fa-clock"
              value={op.countActiveSessions}
              color="icon-service rounded-circle bg-primary-transparent text-primary"
              href={{ pathname: '/parking_sessions/sessions', state: { status: 1 } }}
            />
          </RenderSecure>

          <RenderSecure code="R-AVAIL-PARKING-02">
            <DashCard
              className="col-sm-6 col-md-4 col-xl-3"
              title="Available Parking"
              icon="fas fa-hourglass-start"
              href="/parking-space/available-space"
              value={op.countAvailableParking}
              color="icon-service rounded-circle bg-secondary-transparent text-secondary"
            />
          </RenderSecure>

          <RenderSecure code="R-CLAMP-02">
            <DashCard
              className="col-sm-6 col-md-4 col-xl-3"
              title="Clamped Vehicles"
              icon="fas fa-ban"
              href="/enforcement/clamp_transactions"
              value={op.countClampedVehicles}
              color="icon-service bg-success-transparent rounded-circle text-success"
            />
          </RenderSecure>

          <RenderSecure code="R-TOW-02">
            <DashCard
              className="col-sm-6 col-md-4 col-xl-3"
              title="Towed Vehicles"
              icon="fas fa-wrench"
              href="/enforcement/tow_transactions"
              value={op.countTowedVehicles}
              color="icon-service bg-info-transparent rounded-circle text-info"
            />
          </RenderSecure>
        </>
      )}
    </OperationConsumer>
  ), []);

  return (
    <AuthConsumer>
      {auth => {
        const permissionList = auth.permissionList;

        return (
          <div className="page">
            <LeftSideBar />
            <div className="main-content side-content pt-0" onClick={functions.closeSystemDrawer}>
              <TopBar />
              <div className="container-fluid">
                <PageHeader
                  title="Operations"
                  previousPageTitle="Dashboard"
                  back="/operations"
                  buttons={<Buttons permissionList={permissionList} />}
                />

                <PopNewSession onConfirm={onConfirmStartSession} />

                <div className="row">
                  <CardSection />
                </div>

                <div className="row">
                  <RenderSecure code="R-SESSION-02">
                    <div className="col-sm-12 col-md-12 col-xl-8 col-lg-8">
                      <RecentSessions href="/parking_sessions/sessions" />
                    </div>
                  </RenderSecure>

                  <RenderSecure code="R-MAP-02">
                    <div className="col-sm-12 col-md-12 col-xl-4 col-lg-4">
                      <ReservationChart spaceAvailability={spaceAvailability} />
                    </div>
                  </RenderSecure>
                </div>

                <div className="row">
                  <div className="col-sm-12 col-md-12 col-xl-5 col-lg-5">
                    <RecentClamps />
                  </div>

                  <RenderSecure code="R-SESSION-02">
                    <div className="col-sm-12 col-md-12 col-xl-7 col-lg-7">
                      <OperationsGraph />
                    </div>
                  </RenderSecure>
                </div>
              </div>
            </div>
            <RightSideBar />
          </div>
        );
      }}
    </AuthConsumer>
  );
};

export default Dashboard;
